import _ from 'lodash'
import { getOrg } from '@/api/org'
import { getOrgUser } from '@/api/user'
// import store from '@/store'

// 将组织的数据转成element级联选择器组件所需要的格式，就一个递归然后更改json属性名而已。
// 参数param不传的话，就返回全部的组织，
// param传1的话，就根据当前用户的角色和组织来筛选，并且父节点的disabled伟true。
// param传2的话，返回全部的组织,并且到有tag标记来区分是父子节点。
// param传3的话，返回带有用户的组织
export async function getOrgs(param) {
  let org = null
  if (param === 3) {
    await getOrgUser().then(response => {
      org = [response.data]
    })
  } else {
    await getOrg().then(response => {
      org = [response.data]
    })
  }
  // console.log(org)
  const info = JSON.parse(sessionStorage.getItem('info'))
  const orgArray = org2array(info.org)
  // const org = await store.dispatch('org/getOrg')
  // const orgArray = store.getters.myorgarray

  const aaa = function(data) {
    const bbb = data.map(function(value, key, arr) {
      if (param === 3 && value.user && value.user.length > 0) {
        if (!value.child) {
          value.child = []
        }
        const userOrderBy = _.sortBy(value.user, (o) => {
          return o.role.indexOf('1') === -1
        })
        value.child = value.child.concat(userOrderBy)
      }
      let ccc = null
      const ddd = _.mapKeys(value, function(v, k) {
        if (k === 'id') {
          return 'value'
        } else if (k === 'orgName') {
          return 'label'
        } else if (k === 'child') {
          if (value.child && value.child.length > 0) {
            ccc = aaa(value.child)
          }
          return 'children'
        } else if (param === 3 && k === 'name') {
          return 'label'
        } else {
          return k
        }
      })
      ddd.children = ccc
      return ddd
    })
    return bbb
  }
  const eee = aaa(org)
  // console.log(eee)

  const aa1 = function(data, tag) {
    const bb1 = data.map(function(value, key, arr) {
      if (tag) {
        value.tag = 'child'
      } else if (orgArray[orgArray.length - 1] === value.value) {
        value.tag = 'current'
      } else if (orgArray.indexOf(value.value) > -1) {
        value.tag = 'parent'
      } else {
        value.tag = 'other'
      }
      if (value.children && value.children.length > 0) {
        if (tag) {
          aa1(value.children, true)
        } else if (value.value === orgArray[orgArray.length - 1]) {
          aa1(value.children, true)
        } else {
          aa1(value.children)
        }
        // 因为坑爹的后台不帮你统计人数，那就只能自己统计咯
        value.sum = value.total
        value.children.forEach(e => {
          value.sum = value.sum + e.sum
        })
      } else {
        value.sum = value.total || 0
      }
      return value
    })
    return bb1
  }

  if (param === 2 || param === 3) {
    aa1(eee)
  }

  let fff = eee
  if (param === 1) {
    const orgLength = orgArray.length
    fff = []
    let level = 0
    const a1 = function(data, newOrg) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].value === orgArray[level]) {
          const temp = JSON.parse(JSON.stringify(data[i]))
          newOrg[0] = temp
          if (level < orgLength - 1 && data[i].children && data[i].children.length > 0) {
            newOrg[0].disabled = true
            newOrg[0].children = []
            level = level + 1
            a1(data[i].children, newOrg[0].children)
          }
          break
        }
      }
    }

    a1(eee, fff)
  }
  // console.log(fff)
  return fff
}

// 获取tree结构数据的深度
export function getLevel(treeData) {
  let max = 0
  function each(data, floor) {
    data.length > 0 && data.forEach(e => {
      e.floor = floor
      if (floor > max) {
        max = floor
      }
      if (e.children && e.children.length > 0) {
        each(e.children, floor + 1)
      }
    })
  }
  each(treeData, 1)
  return max
}

// 将对象形式组织数据转成治包含id的数组形式，param参数为text,attrid,attrtext或者不传
export function org2array(org, param) {
  const arrayId = []
  const arrayText = []
  let id = 'id'
  let text = 'orgName'
  if (param === 'attrid' || param === 'attrtext') {
    id = 'value'
    text = 'label'
  }
  const aaa = function(data) {
    arrayId.push(data[id])
    arrayText.push(data[text])
    if (data.child && data.child.length > 0) {
      aaa(data.child[0])
    }
  }
  aaa(org)
  if (param === 'attrid') {
    return arrayId
  } else if (param === 'attrtext') {
    return arrayText
  } else if (param === 'text') {
    return arrayText
  } else {
    return arrayId
  }
}

// 根据attr ,value获取tree结构的id数组
export function getTreeIdsByValue(attr, val, child, array) {
  let aaa = []
  function each(data, tag, ids) {
    data.map(function(value, key, arr) {
      const bbb = JSON.parse(JSON.stringify(ids))
      bbb.push(value.id)
      if (value[attr] === val) {
        aaa = bbb
        tag = false
      }
      if (value[child] && value[child].length > 0) {
        each(value[child], tag, bbb)
      }
    })
  }
  each(array, true, [])
  return aaa
}

// 根据用户id拿到用户的组织id数组
export function getOrgByValue(id, child, array) {
  let aaa = []
  function each(data, tag, ids) {
    data.map(function(value, key, arr) {
      const bbb = JSON.parse(JSON.stringify(ids))
      bbb.push(value.id)
      value.user && value.user.length > 0 && value.user.forEach(e => {
        if (e.id === id) {
          aaa = bbb
          tag = false
        }
      })
      if (value[child] && value[child].length > 0) {
        each(value[child], tag, bbb)
      }
    })
  }
  each(array, true, [])
  return aaa
}

export function hasAuth(level, auth) {
  const buzAuth = JSON.parse(sessionStorage.getItem('info')).buzAuth
  console.log(buzAuth)
  let tag = false
  console.log(level)
  console.log(auth)
  buzAuth.forEach((item) => {
    if (item.substr(0, level * 2) == auth) {
      console.log(item)
      tag = true
    }
  })
  console.log(tag)
  return tag
}

// 复用之前的深度相等判断函数
function isDeepEqual(a, b) {
  if (a === b) return true
  if (typeof a !== typeof b) return false
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false
    return a.every((item, index) => isDeepEqual(item, b[index]))
  }
  return false
}

// 计算普通差集（A - B）
export function getDifference(A, B) {
  return A.filter(a => !B.some(b => isDeepEqual(a, b)))
}

// 计算对称差集（A △ B = (A - B) ∪ (B - A)）
export function getSymmetricDifference(A, B) {
  const diffA = getDifference(A, B) // A有B没有
  const diffB = getDifference(B, A) // B有A没有
  return [...diffA, ...diffB] // 合并两者
}
